import PropTypes from "prop-types"
import React from "react"
import { Controller } from "react-hook-form"

import Form from "src/components/Form"

const JobFormFields = ({
  control,
  errors = {},
  namePlaceholder,
  descriptionPlaceholder,
  autoFocusName = true,
}) => (
  <>
    <div>
      <Form.Label htmlFor="job-name" required>
        Name
      </Form.Label>
      <Controller
        name="name"
        control={control}
        rules={{ required: "Name is required" }}
        render={({ field }) => (
          <Form.TextField
            id="job-name"
            autoFocus={autoFocusName}
            autoComplete="off"
            placeholder={namePlaceholder}
            {...field}
            hasErrors={!!errors.name}
          />
        )}
      />
      {errors.name && <Form.Error>{errors.name.message}</Form.Error>}
    </div>

    <div>
      <Form.Label htmlFor="job-description">Description</Form.Label>
      <Controller
        name="description"
        control={control}
        render={({ field }) => (
          <Form.Textarea
            id="job-description"
            rows={3}
            placeholder={descriptionPlaceholder}
            maxLength={300}
            {...field}
          />
        )}
      />
    </div>
  </>
)

JobFormFields.propTypes = {
  control: PropTypes.object.isRequired,
  errors: PropTypes.object,
  namePlaceholder: PropTypes.string,
  descriptionPlaceholder: PropTypes.string,
  autoFocusName: PropTypes.bool,
}

export default JobFormFields
